import { connect } from 'react-redux'
import { bindActionCreators, compose } from 'redux'
import { withTranslator } from '../components/HOCComponents/withTranslator'

import DashboardApp from '../components/DashboardApp'
import { addFieldsToGroup, selectFields, selectFlightGroup, flushFieldsGroup } from '../actions/fields'
import { toggleVisibility } from '../actions/deliverables'

import { getDashboardView, getSelectedFlightFilterId } from '../selectors/dashboard'
import { getConfigData } from '../selectors/config'
import { getUser, getBiLabsUrl, hasRoleDeactivateDashboard, hasUserRole } from '@layers-frontend/commons/store/selectors/user'
import { USER_ROLES } from '@layers-frontend/commons/constants'
import { errorNotification } from '../actions/notifications'
import { openGoToFieldModal } from '../actions/modal'
import { toggleFocusSearch } from '../actions/search'
import { initializeDashboard } from '../actions/initialization'

import '../utils'
import { getFlightGroups } from '../selectors/flightGroups'

const mapStateToProps = state => {
  const { locale } = state
  return {
    flightGroups: getFlightGroups(state),
    locale,
    user: getUser(state),
    dashboardView: getDashboardView(state),
    isDashboardReady: getConfigData(state, 'isDashboardReady'),
    selectedFlightFilterId: getSelectedFlightFilterId(state),
    biLabsUrl: getBiLabsUrl(state),
    hasRoleDeactivateDashboard: hasRoleDeactivateDashboard(state),
    canUseLayi: hasUserRole(state, USER_ROLES.ROLE_WEB_LAYI)
  }
}

const mapDispatchToProps = dispatch => {
  return bindActionCreators(
    {
      addFieldsToGroup,
      selectFields,
      selectFlightGroup,
      toggleVisibility,
      errorNotification,
      flushFieldsGroup,
      openGoToFieldModal,
      toggleFocusSearch,
      initializeDashboard
    },
    dispatch
  )
}

export default compose(withTranslator, connect(mapStateToProps, mapDispatchToProps))(DashboardApp)
